module.exports = __webpack_public_path__ + "img/FcoinHeroBG.d98a536b.png";